module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/deepcopy/index.js
// module id = 927
// module chunks = 0